import { NextRouter } from "next/router";
import PASentry from "../pa-sentry";
import { getDynamiclyHref } from "./getDynamiclyHref";
import { getPADomain } from "./getPADomain";

export function preformContentLinkClick(router: NextRouter, e: any) {
  const { locale } = router;

  try {
    const targetLink = e?.target?.closest?.("a");
    if (!targetLink) return;
    // when user open via control+click
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) {
      return;
    }

    if (targetLink.hash) {
      e.preventDefault();
      return;
    }

    if (targetLink.href?.startsWith("mailto:")) {
      return;
    }

    const dynamicHref = targetLink.href.replace("/fr-", "/");
    const { href, asPath } = getDynamiclyHref(dynamicHref);

    if (router.asPath === asPath) {
      e.preventDefault();
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    const { isPADomain, routePath } = getPADomain(asPath);
    if (!isPADomain && !asPath.startsWith("partsavatar.ca") && (asPath.startsWith("http") || asPath.startsWith("https") || asPath.startsWith("www"))) {
      window.open(targetLink.href, "_blank");
    } else {
      router.push(href, routePath, { locale })
        .then(() => window.scrollTo(0, 0))
        .catch(() => {
          router.push("/", "/", { locale });
          PASentry.logException(new Error("preformContentLinkClick failed in Router push"), {}, {
            targetLink: dynamicHref,
            href,
          });
        });
    }
  } catch (err) {
    try {
      const targetLink = e?.target?.closest?.("a");
      if (targetLink?.href) {
        window.open(targetLink.href, "_blank");
        PASentry.logException(new Error("preformContentLinkClick failed"), {}, { href: targetLink.href });
      }
    } catch (__err) {
      PASentry.logException(new Error("preformContentLinkClick failed again"), {}, {});
    }
  }
}
